import axios, { Axios, AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { direccionGarantia, garantias, listaGarantias, SeguroAgregarDto, SeguroDeudorEditDto, segurosIncendio, ValueDto } from "../models/garantias";
import { ListResponseDto } from "../../../dtos/ListResponseDto";

const getListaGarantias = async (idMutuo: number) => {

    const response: AxiosResponse<ListResponseDto<listaGarantias>> = await axiosInstance.get(`siscred-api-garantias/v1/garantias-mutuo/mutuos/${idMutuo}/garantia`, {
      
    });

    return response;
}

const getDireccionGarantia = async (idMutuo: number) => {

    const response: AxiosResponse = await axiosInstance.get(`siscred-api-garantias/v1/garantias-mutuo/direccion-garantia`, {
        params: {
            idMutuo: idMutuo,
        }
    });

    return response;
}
const getGarantiasService = async (idMutuo: number, idGarantias: number) => {

    const response: AxiosResponse = await axiosInstance.get(`siscred-api-garantias/v1/garantias-mutuo/mutuos/${idMutuo}/${idGarantias}/garantia`, {
       
    });

    return response;
}

const getTipoHipoteca = async () => {
    const response: AxiosResponse<ListResponseDto<ValueDto>> = await axiosInstance.get(
        `siscred-api-garantias/v1/garantias-mutuo/hipoteca`
    );
    return response;
};


const getEstadoBienRaiz = async () => {
    const response: AxiosResponse<ListResponseDto<ValueDto>> = await axiosInstance.get(
        `siscred-api-garantias/v1/garantias-mutuo/listar-estado-bien-raiz`
    );
    return response;
};


const getTipoBienRaiz = async () => {
    const response: AxiosResponse<ListResponseDto<ValueDto>> = await axiosInstance.get(
        `siscred-api-garantias/v1/garantias-mutuo/listar-tipo-bien-raiz`
    );
    return response;
};

const getTipoConstruccion = async () => {
    const response: AxiosResponse<ListResponseDto<ValueDto>> = await axiosInstance.get(
        `siscred-api-garantias/v1/garantias-mutuo/listar-tipo-construccion`
    );
    return response;
};

const getGarantiasTipoPropiedad = async (idMutuo: number) => {
    const response: AxiosResponse = await axiosInstance.get(
        `siscred-api-garantias/v1/garantias-mutuo/obtener-tipo-propiedad?idMutuo=${idMutuo}`
    );
    return response;
};

const getInstitucionFinanciera = async () => {
    const response: AxiosResponse<ListResponseDto<ValueDto>> = await axiosInstance.get(
        `siscred-api-garantias/v1/garantias-mutuo/listar-institucion-financiera`
    );
    return response;
};

const getSeguroGarantias = async (idMutuo: number) => {

    const axiosResponse: AxiosResponse = await axiosInstance.get(`siscred-api-garantias/v1/garantias-mutuo/obtener-seguro-incendio`, {
        params: {
            id: idMutuo,
        }
    });

    return axiosResponse;
}

const postTipoGarantia = async (data: garantias) => {

    const axiosResponse = await axiosInstance.post(`siscred-api-garantias/v1/garantias-mutuo/guardar-tipo-garantia`, data);

    return axiosResponse;
}

const putTipoGarantia = async (data: garantias) => {

    const axiosResponse: AxiosResponse = await axiosInstance.put(
        `siscred-api-garantias/v1/garantias-mutuo/tipos-garantia/${data.idMutuo}`,
        data
    );

    return axiosResponse;
}

const deleteTipoGarantia = async (idMutuo: number, idGarantias: number) => {

    const axiosResponse: AxiosResponse = await axiosInstance.delete(`siscred-api-garantias/v1/garantias-mutuo/tipo-garantia/${idMutuo}/${idGarantias}`);

    return axiosResponse;
}
const postSeguroIncendio = async (data: segurosIncendio) => {

    const axiosResponse: AxiosResponse = await axiosInstance.post(`siscred-api-garantias/v1/garantias-mutuo/guardar-seguro-incendio`, data);

    return axiosResponse;
}

const putSeguroIncendio = async (data: segurosIncendio) => {

    const axiosResponse: AxiosResponse = await axiosInstance.put(`siscred-api-garantias/v1/garantias-mutuo/actualizar-seguro-incendio/${data.mutuoId}`, data);

    return axiosResponse;
}

const postDireccionGarantia = async (data: direccionGarantia) => {

    const axiosResponse: AxiosResponse = await axiosInstance.post(`siscred-api-garantias/v1/garantias-mutuo/guardar-garantias-tipo-propiedad`, data);

    return axiosResponse;
}

const copyGarantia = async (idSolicitud: string) => {

    const axiosResponse: AxiosResponse<void> = await axiosInstance.post(
        `siscred-api-garantias/v1/garantias-mutuo/copiar-garantia`,
        { idSolicitud: Number(idSolicitud) }
    );

    return axiosResponse.status === 200;
}

export {
    getTipoHipoteca,
    getListaGarantias,
    getDireccionGarantia,
    getGarantiasService,
    getEstadoBienRaiz,
    getTipoBienRaiz,
    getTipoConstruccion,
    getGarantiasTipoPropiedad,
    getInstitucionFinanciera,
    getSeguroGarantias,
    postTipoGarantia,
    putTipoGarantia,
    postSeguroIncendio,
    putSeguroIncendio,
    deleteTipoGarantia,
    postDireccionGarantia,
    copyGarantia
}